export default __webpack_public_path__ + "static/media/despliega.388eb71a.svg";